module.exports = function(input, def, ready) {
  return input ? input : def
}
